{
  "lastUpdatedAt": "2026-06-30T09:23:02.346Z",
  "lastFetchAttemptAt": "2026-06-30T09:23:02.346Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}